export const GOCHAR_RULE_COPY_BLOCKLIST = Object.freeze([
  { term: 'buy', pattern: /\bbuy(?:s|ing|er|ers)?\b/i },
  { term: 'sell', pattern: /\bsell(?:s|ing|er|ers)?\b/i },
  { term: 'invest', pattern: /\binvest(?:s|ed|ing|ment|ments|or|ors)?\b/i },
  { term: 'trade', pattern: /\btrad(?:e|es|ed|ing|er|ers)\b/i },
  { term: 'stock', pattern: /\bstocks?\b/i },
  { term: 'market', pattern: /\bmarkets?(?:ing)?\b/i },
  { term: 'profit', pattern: /\bprofit(?:s|ed|ing|able|ability)?\b/i },
  { term: 'entry', pattern: /\bentr(?:y|ies)\b/i },
  { term: 'exit', pattern: /\bexit(?:s|ed|ing)?\b/i },
  { term: 'bullish', pattern: /\bbullish(?:ness)?\b/i },
  { term: 'bearish', pattern: /\bbearish(?:ness)?\b/i },
]);

export class GocharRuleCopyError extends TypeError {
  constructor({ field, term }) {
    super(`Gochar rule copy rejected: ${field} contains the blocked term “${term}”. Use interpretive astrological wording only.`);
    this.name = 'GocharRuleCopyError';
    this.field = field;
    this.term = term;
  }
}

export function assertCompliantGocharRuleCopy(value, { field = 'rule text' } = {}) {
  if (value === null || value === undefined || value === '') return String(value ?? '');
  const text = String(value);
  const blocked = GOCHAR_RULE_COPY_BLOCKLIST.find(({ pattern }) => pattern.test(text));
  if (blocked) throw new GocharRuleCopyError({ field, term: blocked.term });
  return text;
}

export function assertCompliantGocharRuleContribution(contribution, index = 0) {
  const prefix = `ruleContributions[${index}]`;
  for (const [field, value] of Object.entries({
    id: contribution?.id,
    rule: contribution?.rule,
    reason: contribution?.reason,
    source: contribution?.source,
  })) {
    assertCompliantGocharRuleCopy(value, { field: `${prefix}.${field}` });
  }
  return contribution;
}

export function assertCompliantGocharRuleContributions(contributions = []) {
  if (!Array.isArray(contributions)) {
    throw new TypeError('ruleContributions must be an array.');
  }
  contributions.forEach(assertCompliantGocharRuleContribution);
  return contributions;
}

export function assertCompliantSnapshotRuleCopy(snapshot = {}) {
  for (const section of ['sarvatobhadra', 'kota']) {
    const data = snapshot?.[section] || {};
    assertCompliantGocharRuleCopy(data.trend, { field: `${section}.trend` });
    assertCompliantGocharRuleContributions(data.ruleContributions || []);

    if (section === 'sarvatobhadra' && Array.isArray(data.vedhas)) {
      data.vedhas.forEach((vedha, index) => {
        assertCompliantGocharRuleCopy(vedha?.label, {
          field: `${section}.vedhas[${index}].label`,
        });
      });
    }
  }
  return snapshot;
}
